import api from "@/api";

import deepClone from "@/utils/deep-clone";
import { numerically } from "@/utils/sort-object";

const state = {
    surveys: [],
    goals: [],
};

const getters = {
    surveys(state) {
        return deepClone(state["surveys"]) ?? [];
    },
    goals(state) {
        return deepClone(state["goals"]) ?? [];
    },
};

const actions = {
    getList({ commit }, { payload: { type } }) {
        return api
            .get(
                `/api/tags?status[]=active&status[]=viewOnly${
                    type && type.length ? "&type[]=" + type.join("&type[]=") : ""
                }`,
            )
            .then(res => {
                const list = res?.data;

                if (list && Array.isArray(list)) {
                    commit("updateList", {
                        // Sort numerically by `order`
                        list: list.sort(numerically("order")),
                    });
                }
            });
    },
    update({ dispatch }, { payload: { data } }) {
        return api.post("/api/tags", data).then(() => {
            return dispatch({ type: "getList", payload: { type: [] } });
        });
    },
    updateOrder({ dispatch }, { payload: { data } }) {
        return api.post("/api/tags/order", data).then(() => {
            return dispatch({ type: "getList", payload: { type: [] } });
        });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.surveys = [...list.filter(t => t.type === "surveys")];
        state.goals = [...list.filter(t => t.type === "goals")];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
